export default __webpack_public_path__ + "static/media/hamburger-close.0a2678e1.svg";